import React, { Component } from 'react';

import MessageWindow from '../../Elements/Snackbar/MessageWindow'
import {messageWindow} from '../../Elements/Snackbar/MessageWindow'
import {localization} from '../../Frames/localization'
import {ColorLinearProgress} from '../../../src/App'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RemoveIcon from '@material-ui/icons/Remove';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';


  const requestOptionsExit = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify("")
  }
 class SimpleTable extends Component {
   constructor(props)
   {
     super(props)
     this.state = {
      expanded: false,
      key: undefined,
      listProduct:  [],
      listProductLoad: false,
      checked: null,
      prod_id: this.props.prod_id,
      Count: 0  
     }
     this.handleClick = this.handleClick.bind(this)
     this.handleToggle = this.handleToggle.bind(this)
     this.handleOpenClose = this.handleOpenClose.bind(this)
   }
   createData(SkuSet, id, open, checked) {
    if(checked === true)
    {
      this.state.Count++; 
    }
    return { SkuSet, id , open, checked};
  }
  createDataExtSku(id ,name) {
    return {id, name};
  }
  componentDidMount()
  {
   this.setState({rows: this.Data(this.props)});
  }
  Data(props)
  {
   var rows = 
      this.props.data.SkuSets.map(item => (
        this.createData(item.name, item.id, false, this.Contains(item))
      ))
    return rows;
  }
  handleToggle(event, value)
  {
    if(value.checked == true)
    {
      this.state.Count--;
      value.checked = false;
    }
    else if(value.checked == false)
    {
      if(this.state.Count >= this.props.position)
      {
        messageWindow.OpenMessage("warning", localization.GetTranslate('Cashback.selectMax'))
        this.setState({key: Math.random()})
      }else
      {
        this.state.Count++;
        value.checked = true;
      }
    }
    event.stopPropagation()
    this.forceUpdate()
  }
    handleClick(event,value){
      if(value.open === true)
      {
        value.open = false;
        this.forceUpdate()
      }
      else
      {     
          fetch(`/api/getProducts?id=`+value.id, requestOptionsExit)
          .then((response) => response.json())
          .then((response) => {                  
            this.setState({[value.id]: response})
          })
          this.setState({listProductLoad: true})
          value.open = true;
      }
      event.stopPropagation()
    }
  Contains(value)
  {
    var prod = this.state.prod_id.split(',');
    for(var j=0; j < prod.length; j++)
    {
        if(prod[j] == value.id)
        {
          return true;
        }
    }
    return false;
  }

  handleOpenClose = panel => (event, isExpanded) => {
    this.setState({expanded: isExpanded ? panel : false ,key: Math.random()})
  };
    render()
    {
    return (
        /*<div className={this.props.className}>
            <List id={"List-" +this.props.id}>
              {this.state.rows &&
                this.state.rows.map(value => {
                 const labelId = `checkbox-list-label-${value.id}`;
                  return (
                    <div>
                    <ListItem key={value.id} role={undefined} dense button onClick={() => this.handleToggle(value)}>
                      <ListItemIcon>
                        <Checkbox
                          type="checkbox"
                          edge="start"
                          id={value.id}
                          value={value.id}
                          name={value.id}
                          checked={value.checked}
                          color="primary" 
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </ListItemIcon>
                      <ListItemText className="checked" id={labelId} primary={`${value.SkuSet}`} />
                      <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="comments" onClick={() => this.handleClick(value)}>
                          {value.open &&
                          <ExpandLessIcon />
                          }
                          {!value.open && 
                          <ExpandMoreIcon />
                          }
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Collapse key={this.state.key} in={value.open} timeout="auto" unmountOnExit>
                    {this.state.listProductLoad &&
                    this.state.listProduct.data.map(value => {
                      return(
                    <List component="div" disablePadding>
                      <ListItem>
                            <ArrowRightIcon></ArrowRightIcon>
                            <ListItemText className="checked" primary={value} />
                      </ListItem>
                    </List>
                    );
                    })}
                  </Collapse>
                  </div>
                  
                  );
                })}
              </List>
              <MessageWindow key={this.state.key} ></MessageWindow>
      </div>*/
      <div id={"List-" +this.props.id} className={this.props.className}>
         {this.state.rows &&
                this.state.rows.map(value => {
                  const labelId = `checkbox-list-label-${value.id}`;
                  return (
                  <ExpansionPanel  expanded={this.state.expanded === value.id} onChange={this.props.AppliedSettings.cashback_sku_set_view== true?this.handleOpenClose(value.id):''}>
                    <ExpansionPanelSummary
                      
                      expandIcon={this.props.AppliedSettings.cashback_sku_set_view== true?<ExpandMoreIcon className="CashBackPanelExpandMoreIcon"/>:''}
                      aria-label="Expand"
                      aria-controls="additional-actions1-content"
                      id="additional-actions1-header"
                      onClick={event => this.props.AppliedSettings.cashback_sku_set_view== true? this.handleClick(event,value):''}
                      className="CashBackPanel"
                    >
                      <FormControlLabel
                        aria-label="Acknowledge"
                        className="CashBackPanelLabel"
                        disabled={this.props.disable}
                        onClick={event => this.props.disable == false ? this.handleToggle(event,value):""}
                        control={
                        <Checkbox
                          type="checkbox"
                          edge="start"
                          id={value.id}
                          value={value.id}
                          name={value.id}
                          checked={value.checked}
                          color="primary" 
                          tabIndex={-1}
                          disableRipple
                          disabled={this.props.disable}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                        }
                        label={value.SkuSet}
                      />
                    </ExpansionPanelSummary>
                    {this.props.AppliedSettings.cashback_sku_set_view &&
                    <ExpansionPanelDetails key={this.state.key} className="CashBackPanellist">
                      <Typography color="textSecondary" className="CashBackPanel">
                      {this.state[value.id] &&
                      this.state[value.id].data.map(value => {
                        return(
                          <List  component="div" disablePadding>
                            <ListItem>
                                  <RemoveIcon></RemoveIcon>
                                  <ListItemText className="checked" primary={value} />
                            </ListItem>
                          </List>
                      );
                      })}
                      {!this.state.listProductLoad &&
                      <div>
                          <ColorLinearProgress />   
                      </div>
                      }  
                      </Typography>
                    </ExpansionPanelDetails>
                    }
                  </ExpansionPanel>
                  );
                })
            }
            <MessageWindow key={this.state.key} ></MessageWindow>
    </div>
    );
  }
}
export default SimpleTable;